"use client";

import { c as _c } from "react/compiler-runtime";
import ButtonComponent from "@/components/ui/ButtonComponent";
import Form from "next/form";
import { useActionState, useEffect, useState } from "react";
import { finishRegistration } from "../actions";
import { FinishRegistrationEmailInput } from "./finish-registration-email-input";
import InputComponent from "@/components/ui/InputComponent";
import ModalComponent from "@/components/modals/ModalComponent";
import Link from "next/link";
import { FinishRegistrationFormProps } from "../types";
import { useTranslations } from "next-intl";
import { useRouter } from "@/features/i18n";
import { toast } from "sonner";
export const FinishRegistrationForm: React.FC<FinishRegistrationFormProps> = t0 => {
  const $ = _c(86);
  const {
    emailPromise,
    inviteToken,
    success
  } = t0;
  const router = useRouter();
  const [isModalOpen, setIsModalOpen] = useState(success || false);
  const t = useTranslations("CorrectFinishRegistration");
  let t1;
  if ($[0] !== router) {
    t1 = () => {
      setIsModalOpen(false);
      router.push("/login");
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSuccessRedirect = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "",
      password: "",
      repeatPassword: "",
      error: "",
      fieldErrors: undefined
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [state, formAction, isPending] = useActionState(finishRegistration, t2);
  const labels = useTranslations("Labels");
  const placeholders = useTranslations("Placeholders");
  const register = useTranslations("Register");
  const modals = useTranslations("Modals");
  const buttons = useTranslations("Buttons");
  let t3;
  if ($[3] !== isPending || $[4] !== state) {
    t3 = () => {
      if (!isPending && state?.error) {
        toast.error(state.error);
      }
    };
    $[3] = isPending;
    $[4] = state;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = state?.error;
  let t5;
  if ($[6] !== isPending || $[7] !== t4) {
    t5 = [isPending, t4];
    $[6] = isPending;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t3, t5);
  let t6;
  if ($[9] !== inviteToken) {
    t6 = <input type="hidden" name="token" value={inviteToken} />;
    $[9] = inviteToken;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== emailPromise) {
    t7 = <FinishRegistrationEmailInput emailPromise={emailPromise} />;
    $[11] = emailPromise;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== labels) {
    t8 = labels("labelName");
    $[13] = labels;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== placeholders) {
    t9 = placeholders("placeholderName");
    $[15] = placeholders;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = state?.name;
  const t11 = state?.fieldErrors?.name?.[0];
  let t12;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t8 || $[20] !== t9) {
    t12 = <InputComponent id="name" name="name" label={t8} placeholder={t9} isRequired={true} defaultValue={t10} className="input--full" error={t11} />;
    $[17] = t10;
    $[18] = t11;
    $[19] = t8;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== labels) {
    t13 = labels("labelPassword");
    $[22] = labels;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== placeholders) {
    t14 = placeholders("placeholderPassword");
    $[24] = placeholders;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = state?.password;
  const t16 = state?.fieldErrors?.password?.[0];
  let t17;
  if ($[26] !== t13 || $[27] !== t14 || $[28] !== t15 || $[29] !== t16) {
    t17 = <InputComponent id="password" name="password" type="password" label={t13} placeholder={t14} isRequired={true} defaultValue={t15} className="input--full" error={t16} />;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== labels) {
    t18 = labels("labelRepeatPassword");
    $[31] = labels;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== placeholders) {
    t19 = placeholders("placeholderRepeatPassword");
    $[33] = placeholders;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const t20 = state?.repeatPassword;
  const t21 = state?.fieldErrors?.repeatPassword?.[0];
  let t22;
  if ($[35] !== t18 || $[36] !== t19 || $[37] !== t20 || $[38] !== t21) {
    t22 = <InputComponent id="repeatPassword" name="repeatPassword" type="password" label={t18} placeholder={t19} isRequired={true} defaultValue={t20} className="input--full" error={t21} />;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t12 || $[41] !== t17 || $[42] !== t22 || $[43] !== t7) {
    t23 = <section className="auth__finish-registration-fields">{t7}{t12}{t17}{t22}</section>;
    $[40] = t12;
    $[41] = t17;
    $[42] = t22;
    $[43] = t7;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== modals) {
    t24 = modals("requiredFieldsMessage");
    $[45] = modals;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t24) {
    t25 = <p className="auth__required-message">{t24}</p>;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== register) {
    t26 = register("text-link-cookies");
    $[49] = register;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== register) {
    t27 = register("link-cookies");
    $[51] = register;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t27) {
    t28 = <Link href="#" className="auth__link-primary">{t27}</Link>;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== t26 || $[56] !== t28) {
    t29 = <p className="auth__cookies-message">{t26}{" "}{t28}</p>;
    $[55] = t26;
    $[56] = t28;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== buttons) {
    t30 = buttons("buttonRegister");
    $[58] = buttons;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== isPending || $[61] !== t30) {
    t31 = <ButtonComponent size="sm" type="submit" className="auth__button-center" disabled={isPending} loading={isPending}>{t30}</ButtonComponent>;
    $[60] = isPending;
    $[61] = t30;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t25 || $[64] !== t29 || $[65] !== t31) {
    t32 = <section className="auth__finish-registration-footer">{t25}{t29}{t31}</section>;
    $[63] = t25;
    $[64] = t29;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== t23 || $[68] !== t32 || $[69] !== t6) {
    t33 = <Form action={formAction} className="auth__form-base auth__finish-registration-form">{t6}{t23}{t32}</Form>;
    $[67] = t23;
    $[68] = t32;
    $[69] = t6;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== t) {
    t34 = t("title");
    $[71] = t;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = {
      textAlign: "center",
      marginBottom: "1rem"
    };
    $[73] = t35;
  } else {
    t35 = $[73];
  }
  let t36;
  if ($[74] !== t) {
    t36 = t("message");
    $[74] = t;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  let t37;
  if ($[76] !== t36) {
    t37 = <p style={t35}>{t36}</p>;
    $[76] = t36;
    $[77] = t37;
  } else {
    t37 = $[77];
  }
  let t38;
  if ($[78] !== handleSuccessRedirect || $[79] !== isModalOpen || $[80] !== t34 || $[81] !== t37) {
    t38 = <ModalComponent id="finish-registration-success-modal" title={t34} isOpen={isModalOpen} onClose={handleSuccessRedirect} onConfirm={handleSuccessRedirect} buttonConfirmText="buttonLogin">{t37}</ModalComponent>;
    $[78] = handleSuccessRedirect;
    $[79] = isModalOpen;
    $[80] = t34;
    $[81] = t37;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] !== t33 || $[84] !== t38) {
    t39 = <>{t33}{t38}</>;
    $[83] = t33;
    $[84] = t38;
    $[85] = t39;
  } else {
    t39 = $[85];
  }
  return t39;
};